var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import styled, { css } from 'styled-components';
import { AccordionItemPanel as A11yAccordionItemPanel } from 'react-accessible-accordion';
import { Link } from '../../Link';
import { get } from '../../tools/utils';
import { useAccordion } from '../AccordionContext';
import { AccordionItemContext } from '../AccordionItemContext';
var NavigationLinkListContainer = styled.nav(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: #480348;\n"], ["\n  background-color: #480348;\n"])));
var NavigationUL = styled.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n"], ["\n  margin: 0;\n  padding: 0;\n"])));
var NavigationLinkContainer = styled.li(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n  height: 32px;\n\n  ", "\n"], ["\n  border-bottom: 1px solid ", ";\n  height: 32px;\n\n  ", "\n"])), get.colors('slate-3'), function (_a) {
    var media = _a.theme.media;
    return "\n    ".concat(media.down('md'), " {\n      height: 45px;\n  ");
});
var NavigationLink = styled(Link)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", ";\n  /** Padding left of caret, padding right of caret, width of caret */\n  padding-left: calc(", " * 2 + ", ");\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  flex-direction: column;\n  justify-content: center;\n  font-size: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n\n  ", "\n"], ["\n  color: ", ";\n  /** Padding left of caret, padding right of caret, width of caret */\n  padding-left: calc(", " * 2 + ", ");\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  flex-direction: column;\n  justify-content: center;\n  font-size: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n\n  ", "\n"])), get.colors('white'), get.space('md'), get.iconSize('xs'), get.fontSizes('md'), get.colors('white'), function (_a) {
    var backgroundColor = _a.backgroundColor, colors = _a.theme.colors;
    if (!backgroundColor) {
        return css(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
    }
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), colors[backgroundColor]);
});
var LinearGradient = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  height: 8px;\n  background-image: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.03) 0%,\n    rgba(249, 249, 249, 0.03) 100%\n  );\n"], ["\n  height: 8px;\n  background-image: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.03) 0%,\n    rgba(249, 249, 249, 0.03) 100%\n  );\n"])));
var AccordionItemBackground = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), function (_a) {
    var colors = _a.theme.colors;
    return colors.white;
});
var InnerAccordionItemBox = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  padding: ", ";\n  padding-top: ", ";\n"], ["\n  padding: ", ";\n  padding-top: ", ";\n"])), get.space('md'), get.space('xxs'));
var AccordionItemBox = function (_a) {
    var variant = _a.variant, children = _a.children;
    if (variant === 'CONTAINER') {
        return (React.createElement(AccordionItemBackground, null,
            React.createElement(LinearGradient, null),
            React.createElement(InnerAccordionItemBox, null, children)));
    }
    return React.createElement(React.Fragment, null, children);
};
var StyledA11yAccordionItemPanel = styled(A11yAccordionItemPanel)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  border: none;\n  ", "\n  &:focus {\n    outline: none;\n  }\n"], ["\n  border: none;\n  ", "\n  &:focus {\n    outline: none;\n  }\n"])), function (_a) {
    var $variant = _a.$variant, _b = _a.theme, colors = _b.colors, space = _b.space, iconSize = _b.iconSize;
    switch ($variant) {
        case 'CONTAINER':
            return css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n          border-bottom: 1px solid ", ";\n        "], ["\n          border-bottom: 1px solid ", ";\n        "])), colors['slate-2']);
        case 'STEPPED_PROCESS':
            return css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n          /* The 3px offset aligns the edge with the caret in the header */\n          padding: 0 ", " ", " calc(", " - 3px);\n          background-color: ", ";\n        "], ["\n          /* The 3px offset aligns the edge with the caret in the header */\n          padding: 0 ", " ", " calc(", " - 3px);\n          background-color: ", ";\n        "])), space.md, space.lg, space.md, colors.white);
        case 'CONTAINERLESS':
            return css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n          background-color: inherit;\n          padding-left: calc(", " + ", ");\n        "], ["\n          background-color: inherit;\n          padding-left: calc(", " + ", ");\n        "])), space.md, iconSize.xl);
        case 'NAVIGATION':
            return css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n          box-shadow: inset 0 4px 0 0 rgba(0, 0, 0, 0.1);\n          background-color: inherit;\n        "], ["\n          box-shadow: inset 0 4px 0 0 rgba(0, 0, 0, 0.1);\n          background-color: inherit;\n        "])));
        default:
            return css(templateObject_14 || (templateObject_14 = __makeTemplateObject([""], [""])));
    }
});
var AccordionItemPanel = function (_a) {
    var content = _a.content, isExpanded = _a.isExpanded, closePanel = _a.closePanel, uuid = _a.uuid;
    var variant = content.variant;
    var panelToOpenOnMount = useAccordion().panelToOpenOnMount;
    var _b = __read(React.useState(uuid !== undefined && uuid === panelToOpenOnMount), 2), isPreExpanding = _b[0], setIsPreExpanding = _b[1];
    var handleFocus = React.useCallback(function (node) {
        if (node && isExpanded && !isPreExpanding) {
            node.focus();
        }
        if (isPreExpanding) {
            setIsPreExpanding(false);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isExpanded]);
    switch (content.variant) {
        case 'CONTAINER':
        case 'CONTAINERLESS':
        case 'STEPPED_PROCESS':
            return (React.createElement(StyledA11yAccordionItemPanel, { "$variant": variant },
                React.createElement(AccordionItemBox, { variant: variant },
                    React.createElement(AccordionItemContext.Provider, { value: { handleFocus: handleFocus, isExpanded: isExpanded, closePanel: closePanel } }, content.payload))));
        case 'NAVIGATION':
            return (React.createElement(StyledA11yAccordionItemPanel, { "$variant": variant },
                React.createElement(AccordionItemBox, { variant: variant },
                    React.createElement(NavigationLinkListContainer, null,
                        React.createElement(NavigationUL, null, content.routes.map(function (_a, index) {
                            var title = _a.title, url = _a.url, color = _a.color;
                            var key = "".concat(title, "-").concat(index);
                            return (React.createElement(NavigationLinkContainer, { key: key },
                                React.createElement(NavigationLink, __assign({ id: "accordion-navigation-link", text: title, to: url, backgroundColor: color }, (index === 0 ? { ref: handleFocus } : {})))));
                        }))))));
        default:
            return (React.createElement(StyledA11yAccordionItemPanel, { "$variant": variant },
                React.createElement(AccordionItemBox, { variant: variant })));
    }
};
export default AccordionItemPanel;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;
//# sourceMappingURL=AccordionItemPanel.js.map